import { StoreState } from "..";

export const getFlightsInterlinking = (state: StoreState) => state.flightsInterlinking;
